"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLazyComponent = exports.getInstance = exports.getModuleParams = void 0;
var react_module_container_1 = require("react-module-container");
var business_manager_api_1 = require("@wix/business-manager-api");
exports.getModuleParams = function () {
    return business_manager_api_1.getModule(business_manager_api_1.ModuleId.Engage).moduleParams;
};
exports.getInstance = function () {
    var engageAppDefId = business_manager_api_1.getModule(business_manager_api_1.ModuleId.Engage).appDefId;
    return business_manager_api_1.getCurrentInstance(engageAppDefId);
};
exports.createLazyComponent = function (_a) {
    var componentName = _a.componentName, bundleFile = _a.bundleFile, _b = _a.dependencies, dependencies = _b === void 0 ? [] : _b;
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = this;
            var minified = function (debug) { return (debug ? '' : '.min'); };
            var options = {
                files: __spreadArrays(dependencies, [
                    "" + props.config.topology.inboxSettingsStaticsUrl + bundleFile + ".bundle" + minified(props.debug) + ".js",
                    "" + props.config.topology.inboxSettingsStaticsUrl + bundleFile + minified(props.debug) + ".css",
                ]),
                component: componentName,
            };
            _this = _super.call(this, props, options) || this;
            return _this;
        }
        return class_1;
    }(react_module_container_1.ReactLazyComponent));
};
//# sourceMappingURL=bmUtils.js.map